var map = {
	"./amex.png": 1036,
	"./diners.png": 1037,
	"./discover.png": 1038,
	"./jcb.png": 1039,
	"./maestro.png": 1268,
	"./mastercard.png": 1040,
	"./stripe.png": 1041,
	"./union.png": 1042,
	"./unknown.png": 717,
	"./visa.png": 1043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1267;